// Module
var code = "<svg width=\"24\" height=\"24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"5\" y=\"5\" width=\"11\" height=\"11\" rx=\"2\" fill=\"#fff\"/><rect opacity=\".3\" x=\"8\" y=\"8\" width=\"11\" height=\"11\" rx=\"2\" fill=\"#fff\"/></svg>";
// Exports
module.exports = code;